module.exports = __webpack_public_path__ + "static/media/user-visor.271468bd.svg";